import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Quiz from "@/pages/Quiz";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import AdminLeads from "@/pages/AdminLeads";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App font-sans antialiased">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
